var _linearGradient, _circle, _circle2, _circle3, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _path10, _path11, _linearGradient10, _path12, _linearGradient11, _path13, _linearGradient12, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsortedAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: -2336.635,
    y1: -13.591,
    x2: -2335.635,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 154.359,
    cy: 57.594,
    r: 20.506
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 99.166,
    cy: 39.37,
    r: 20.506
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 43.973,
    cy: 57.594,
    r: 20.506
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 43.933,
    y1: 59.043,
    x2: 83.767,
    y2: 59.043,
    gradientTransform: "matrix(.851 .2917 -.2919 .8514 22.28 14.074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.956 61.6s10.937 6.923 16.856 23.118c4.36 12.581 3.996 19.621 3.996 19.621",
    fill: "none",
    stroke: "url(#SVGID_1_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 38.79,
    y1: 46.969,
    x2: 48.495,
    y2: 46.969,
    gradientTransform: "rotate(18.922 -2.778 76.267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M49.327 69.37l-1.511-8.649 8.132-1.505"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 28.732,
    y1: -17.135,
    x2: 54.125,
    y2: -17.135,
    gradientTransform: "rotate(44.145 -20.522 94.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.451 42.145s3.86 11.574 2.146 30.659",
    fill: "none",
    stroke: "url(#SVGID_3_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 11.093,
    y1: -37.873,
    x2: 20.799,
    y2: -37.873,
    gradientTransform: "rotate(60.184 -12.635 75.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M95.553 47.625l4.568-7.498 7.106 4.232"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: -265.35,
    y1: 207.953,
    x2: -237.313,
    y2: 207.953,
    gradientTransform: "scale(-1 1) rotate(30.16 49.221 336.457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.882 57.173s-7.261 13.818-9.587 34.329",
    fill: "none",
    stroke: "url(#SVGID_5_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: -209.954,
    y1: 257.611,
    x2: -200.249,
    y2: 257.611,
    gradientTransform: "scale(-1 1) rotate(46.203 54.838 222.363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M154.311 63.674l-2.62-8.38-7.919 2.39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M118.784 135.618l22.791-21.302c2.419.837 6.214.948 8.969-1.634a8.1 8.1 0 002.44-7.326l-4.722 4.454-5.617-1.144-.442-5.322 4.721-4.423c-2.632-.662-5.501.094-7.464 1.933-2.756 2.582-3.296 6.633-1.562 9.8l-22.69 21.262c-3.022-1.789-6.975-1.464-9.667 1.058a8.1 8.1 0 00-2.44 7.326l4.722-4.454 5.617 1.144.443 5.322-4.721 4.423c2.632.662 5.501-.094 7.464-1.933 2.819-2.643 3.274-7.044 2.158-9.184z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 49.241,
    y1: 119.972,
    x2: 96.95,
    y2: 119.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M50.491 111.228l11.071 17.488h23.527L95.7 111.228"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 49.241,
    y1: 137.926,
    x2: 96.95,
    y2: 137.926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M95.7 147.135l-11.072-18.418H61.101l-10.61 18.418"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9 134.316h-7.628"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.854 110.549V85.944h37.953v37.395"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 90.856,
    y1: 95.037,
    x2: 118.666,
    y2: 95.037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M92.106 95.037h25.311"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 90.878,
    y1: 104.06,
    x2: 118.688,
    y2: 104.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M92.128 104.06h25.31"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2",
    gradientUnits: "userSpaceOnUse",
    x1: 101.72,
    y1: 113.549,
    x2: 118.623,
    y2: 113.549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_45578c15a57a683085c5edeb45cc06f679190c1234ab86c3d641363e26bf59e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M102.97 113.549h14.403"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M120.086 85.386v-5.767H79.714v31.069M50.21 110.874h45.932v36.558H50.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsortedAsset);
export default __webpack_public_path__ + "static/media/unsortedAsset.a18782d9aec08d0a7b9961e5498b5b0b.svg";
export { ForwardRef as ReactComponent };